/** Envoi pas encore accepté par le serveur : le bureau et la PWA peuvent prévenir avant de fermer. */

type Listener = () => void;

let busy = false;
let prompt = false;
let allowClose = false;
let installed = false;
const listeners = new Set<Listener>();

function emit(): void {
  for (const listener of listeners) listener();
}

function embedded(): boolean {
  try {
    return window.parent !== window;
  } catch {
    return true;
  }
}

function publish(): void {
  if (!embedded()) return;
  try {
    window.parent.postMessage({ type: "aurelia:mail-sending-state", busy }, "*");
  } catch {
    /* le bureau a déjà retiré la fenêtre */
  }
}

export function setMailSendBusy(next: boolean): void {
  busy = next;
  if (!next) {
    prompt = false;
    allowClose = false;
  }
  publish();
  emit();
}

export function installMailSendLeave(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("keydown", (event) => {
    if (!busy || allowClose || embedded()) return;
    const closeTab = (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "w";
    if (!closeTab) return;
    event.preventDefault();
    prompt = true;
    emit();
  });
  window.addEventListener("beforeunload", (event) => {
    if (!busy || allowClose) return;
    event.preventDefault();
    event.returnValue = "";
  });
}

export function subscribeMailSendLeave(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function mailSendLeavePromptOpen(): boolean {
  return prompt;
}

export function waitForMailSend(): void {
  prompt = false;
  emit();
}

export function closeDespiteMailSend(): void {
  prompt = false;
  allowClose = true;
  emit();
  window.close();
}
